export default __webpack_public_path__ + "static/media/interface.0f28aa34.png";